import Component from "components/Component";
import Options from "components/common/Options";
import * as labels from "config.labels";
import { connect } from "react-redux";
import * as staticDataHooks from "store/hooks/staticDataHooks";
import * as rateChangeSlice from "store/rateChange";

const componentDefns = [
  {
    key: "structure",
    name: "Structure",
    labelKey: labels.RATE_CHANGE_COMPONENT_SELECTOR_STRUCTURE,
  },
  {
    key: "commission",
    name: "Commission",
    labelKey: labels.RATE_CHANGE_COMPONENT_SELECTOR_COMMISSION,
  },
  {
    key: "exposure",
    name: "Exposure",
    labelKey: labels.RATE_CHANGE_COMPONENT_SELECTOR_EXPOSURE,
  },
  {
    key: "uwJudgment",
    name: "UW Judgment",
    labelKey: labels.RATE_CHANGE_COMPONENT_SELECTOR_UW_JUDGMENT,
  },
  {
    key: "inflation",
    name: "Inflation",
    labelKey: labels.RATE_CHANGE_COMPONENT_SELECTOR_INFLATION,
  },
];

const ComponentSelector = ({
  activeLayerRateChange,
  updateLayerRateChange,
}) => {
  const translateLabel = staticDataHooks.useTranslator("uiLabels");
  const options = componentDefns.map((defn) => {
    return {
      id: defn.key,
      label: defn.labelKey
        ? translateLabel(defn.labelKey, { default: defn.name })
        : defn.name,
      selected: !activeLayerRateChange?.componentDisabled?.[defn.key],
    };
  });

  return (
    <Component
      title={translateLabel(labels.RATE_CHANGE_COMPONENT_SELECTOR_TITLE, {
        default: "Components",
      })}
      subtitle={translateLabel(labels.RATE_CHANGE_COMPONENT_SELECTOR_SUBTITLE, {
        default: "Select the components to include in the Rate Change calc.",
      })}
    >
      <Options
        items={options}
        onClick={({ id, selected }) =>
          updateLayerRateChange({
            componentDisabled: {
              ...activeLayerRateChange?.componentDisabled,
              [id]: selected,
            },
          })
        }
      />
    </Component>
  );
};

const mapStateToProps = (state) => {
  return {
    activeLayerRateChange: rateChangeSlice.selectActiveLayerRateChange(state),
  };
};

const mapDispatchToProps = {
  updateLayerRateChange: rateChangeSlice.updateLayerProperties,
};

export default connect(mapStateToProps, mapDispatchToProps)(ComponentSelector);
